const API_BASE_URL = process.env.REACT_APP_API_URL;

const apiUrls = {
  auth: {
    login: `${API_BASE_URL}/auth/login`,
    register: `${API_BASE_URL}/auth/register`,
    logout: `${API_BASE_URL}/logout`,
    resetPassword: `${API_BASE_URL}/auth/reset-password`,
    changePassword: `${API_BASE_URL}/auth/change-password`,
    forgotPassword: `${API_BASE_URL}/auth/forgot-password`,
    verifyOtp: `${API_BASE_URL}/auth/verify-otp`,
  },
  roles: {
    getAll: "/roles",
  },
  jobs: {
    job: `${API_BASE_URL}/jobs`,
  },
  user: {
    profile: `${API_BASE_URL}/user/profile`,
    updateProfile: `${API_BASE_URL}/user/update`,
  },
  application: {
    userApplications: `${API_BASE_URL}/application/user`,
  },
  tests: {
    getTest: `${API_BASE_URL}/tests`,
    submitInitialTest: `${API_BASE_URL}/submit-initial-test`,
    submitFinalTest: `${API_BASE_URL}/submit-final-test`,
    training: `${API_BASE_URL}/training`,
    result: `${API_BASE_URL}/results`,
  },
  training: {
    markCompleted: `${API_BASE_URL}/training/complete`,
  },
  appstatus: {
    status: `${API_BASE_URL}/applications/status`,
    archiveApp: `${API_BASE_URL}/job-application/archive`
  },
  services: {
    customerServiceRequest: `${API_BASE_URL}/services/customer/postTask`,
    selectHandymanOffer: `${API_BASE_URL}/services/customer/offers/accept`,
    approveCompletion: `${API_BASE_URL}/services/customer/approve-completion`,
    confirmCompletion: `${API_BASE_URL}/services/customer/confirm-completion`,
    cancelServiceRequest: `${API_BASE_URL}/services/customer/cancel`,
    acceptOffer: `${API_BASE_URL}/services/customer/offers/accept`,
    getMyTasks: `${API_BASE_URL}/services/customer/myTasks`,
    getCustomerTaskById: `${API_BASE_URL}/services/customer/tasks`,
  },
  // Handyman job lifecycle endpoints
  handymanJob: {
    startJourney: `${API_BASE_URL}/handyman/job/start-journey`,
    updateLocation: `${API_BASE_URL}/handyman/job/update-location`,
    arrived: `${API_BASE_URL}/handyman/job/arrived`,
    startWork: `${API_BASE_URL}/handyman/job/start-work`,
    completeWork: `${API_BASE_URL}/handyman/job/complete-work`,
    confirmPaymentReceived: `${API_BASE_URL}/handyman/job/confirm-payment-received`,
    cancelJob: `${API_BASE_URL}/handyman/job/cancel`,
    getActiveJob: `${API_BASE_URL}/handyman/job/active`,
    getMyJobs: `${API_BASE_URL}/handyman/job/my-jobs`,
    rateCustomer: `${API_BASE_URL}/handyman/job/rate-customer`,
  },
  handymanOffers: {
    getMyOffers: `${API_BASE_URL}/handyman/offers`,
  },
  candidate: {
    getReferralTasks: `${API_BASE_URL}/candidate/referrals/tasks`,
    dashboard: `${API_BASE_URL}/candidate/dashboard`,
  },
  chat: {
    createOrGet: `${API_BASE_URL}/chat/create`,
    sendMessage: `${API_BASE_URL}/chat/message`,
    getChatMessages: (chatId) => `${API_BASE_URL}/chat/${chatId}/messages`,
    markAsRead: (chatId) => `${API_BASE_URL}/chat/${chatId}/read`,
  },
  dispute: {
    raiseDispute: `${API_BASE_URL}/dispute/raise`,
  }

};

export default apiUrls;